import { useEffect } from 'react';
import {
  StyledTextField,
  StyledForm,
  FormSection,
  StyledFormSectionContainer,
  StyledButtonContainer,
} from './EditPersonalDetails.styles';
import { Typography, Button } from '@mui/material';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateEmployeeDetails } from '../../../../../redux/actions/employeesActions';
import PropTypes from 'prop-types';

const EditPersonalDetails = ({ employeeId, handleOpenDrawer }) => {
  const dispatch = useDispatch();
  const employee = useSelector((state) => state.employees.employees.find((emp) => emp.id === employeeId));

  // Initialize form data from employee props
  const [formData, setFormData] = useState({
    name: employee?.displayName || '',
    ...(employee?.personalDetails || {}),
  });

  // Add this effect to update form when employee data changes
  useEffect(() => {
    setFormData({
      name: employee?.displayName || '',
      ...(employee?.personalDetails || {}),
    });
  }, [employee]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    dispatch(updateEmployeeDetails(employee.id, formData));
    handleOpenDrawer('user', employee);
  };

  return (
    <StyledForm onSubmit={handleSubmit}>
      <StyledFormSectionContainer>
        <FormSection>
          <Typography variant="h6GrayUppercase">Your Personal Data</Typography>
          {[
            { label: 'Name', name: 'name' },
            { label: 'Phone', name: 'phone' },
            { label: 'Address', name: 'address' },
            { label: 'City', name: 'city' },
            { label: 'State', name: 'state' },
            { label: 'ZIP', name: 'zip' },
          ].map((field) => (
            <div key={field.label}>
              <StyledTextField
                name={field.name}
                label={field.label}
                variant="filled"
                value={formData[field.name] || ''}
                onChange={handleChange}
                fullWidth
              />
            </div>
          ))}
        </FormSection>

        <FormSection>
          <Typography variant="h6GrayUppercase">Emergency Contact</Typography>
          {[
            { label: 'Name', name: 'emergencyName' },
            { label: 'Relationship', name: 'emergencyRelationship' },
            { label: 'Phone', name: 'emergencyPhone' },
          ].map((field) => (
            <div key={field.label}>
              <StyledTextField
                name={field.name}
                label={field.label}
                variant="filled"
                size="medium"
                value={formData[field.name] || ''}
                onChange={handleChange}
                fullWidth
              />
            </div>
          ))}
        </FormSection>
      </StyledFormSectionContainer>
      <StyledButtonContainer>
        <Button variant="primary" type="submit">
          Save
        </Button>
        <Button variant="primaryDestructive" type="button" onClick={() => handleOpenDrawer('user', employee)}>
          Cancel
        </Button>
      </StyledButtonContainer>
    </StyledForm>
  );
};

EditPersonalDetails.propTypes = {
  employeeId: PropTypes.string.isRequired,
  handleOpenDrawer: PropTypes.func.isRequired,
};

export default EditPersonalDetails;
